import React from 'react';
import { useSelector } from "react-redux";
import BookingItem from "../BookingItem/BookingItem";
import './bookingList.css';

const BookingList = () => {
    const booking = useSelector(state => state.booking);
    const user_bar = useSelector(state => state.user_bar);
    const choice_address_form = useSelector(state => state.choice_address_form);

    return (
        <>
            {
                choice_address_form.addresses.length > 1 && choice_address_form.current_address &&
                <div className="list__address">{ choice_address_form.current_address }</div>
            }
            <div className="list">
                {
                    !booking?.reserves.length
                        ?
                        <div className="empty_list">Нет занятий на указанную дату</div>
                        : false
                }
                {
                    !user_bar && booking?.reserves?.map(elem => {
                        return <BookingItem data={ elem } key={ elem.id }/>;
                    })
                }
            </div>
        </>
    );
};

export default BookingList;